module.exports = require('./helpers/bundle-url').getBundleURL('bLxZJ') + "flask-portfolio.a6b17744.png" + "?" + Date.now();